import React, { Component } from "react";
import "./theme.css";

class Template extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // menu: {
      //   bg: "#fff"
      // },
      // font: {
      //   primary: {
      //     color: "#23282c"
      //   },
      //   secondary: {
      //     color: "#fff"
      //   },
      //   form: {
      //     color: "#5c6873"
      //   }
      // },
      // hover: {
      //   primary: {
      //     bgColor: "#20a8d8",
      //     fontColor: "#fff"
      //   }
      // },
      // colors: {
      //   primaryGrey: "#c8ced3",
      //   primary: "#20a8d8",
      //   footerColor: "#f0f3f5",
      //   secondary: "#1872cd",
      //   secondary50alpha: "rgba(17, 57, 193, 0.49)"
      // }
    };
  }

  render() {
    return (
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
            `
        }}
      />
    );
  }
}

export default Template;
